import { Actions } from './IP-location.actions';
import { IP_LOCATION_SET_DATA, IP_LOCATION_SET_ERROR } from './IP-location.constants';

export interface IState {
    data: {
        countryCode: string
    } | null;
    error: Error | null;
}

export const initialState: IState = {
    data: null,
    error: null
};

export const reducerKey = 'IPLocation' as const;

export const IPLocation = (state: IState = initialState, action: Actions): IState => {
    switch (action.type) {
    case IP_LOCATION_SET_DATA:
        return {
            ...state,
            error: null,
            data: action.payload
        };
    case IP_LOCATION_SET_ERROR:
        return {
            ...state,
            data: null,
            error: action.payload
        };
    default:
        return state;
    }
};

export default IPLocation;
